<template>
  <div class="row" v-if="skeleton">
    <div class="col-12">
      <PuSkeleton style="height: calc(94vh - 180px);"/>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SkeletonBody',
  props: {
    skeleton: {
      type: Boolean,
      default: true,
    }
  },
}
</script>
